const USUARIOS_CON_PERMISO = ["1", "7", "34", "591", "740", "743", "747", "815"]

const usuarioTienePermisoSuc = (id) => {
  return USUARIOS_CON_PERMISO.includes(String(id))
}

const permisos = ["Peticiones", "nuevo"]

export { USUARIOS_CON_PERMISO, usuarioTienePermisoSuc, permisos }